export const examAdminShell = {
  sectionLabel: "Admin Portal",
  brandSubtitle: "AI-powered assessment admin portal",
  menu: {
    dashboard: "Dashboard",
    staffUsers: "Exam Staff",
    candidateUsers: "Candidates",
    systemSettings: "System",
    rolePermissions: "Role Permissions",
    customFields: "Custom Fields",
    assetsCenter: "Assets",
    auditLogs: "Audit Logs",
    auditLoginLogs: "Login Logs",
    auditOperationLogs: "Operation Logs",
    questions: "Questions",
    papers: "Papers",
    exams: "Exams",
    execution: "Execution",
    submissions: "Code Submissions",
    dockerImages: "Images",
    dockerInstances: "Instances",
    review: "Review",
    aiTasks: "AI Tasks",
  },
  breadcrumbs: {
    home: "Admin Portal",
    dashboard: "Dashboard",
    staffUsers: "Exam Staff",
    candidateUsers: "Candidates",
    systemSettings: "System",
    rolePermissions: "Role Permissions",
    customFields: "Custom Fields",
    assetsCenter: "Assets",
    auditLogs: "Audit Logs",
    auditLoginLogs: "Login Logs",
    auditOperationLogs: "Operation Logs",
    questions: "Questions",
    papers: "Papers",
    exams: "Exams",
    execution: "Execution",
    submissions: "Code Submissions",
    dockerImages: "Images",
    dockerInstances: "Instances",
    review: "Review",
    aiTasks: "AI Tasks",
  },
  routes: {
    businessGroup: "Core Workflow",
    organizationGroup: "Users & Organization",
    resourceGroup: "Resources & Environment",
    platformGroup: "System & Audit",
    userGroup: "User Management",
    systemGroup: "System Management",
    dockerGroup: "Image & Container Management",
    auditAll: "All Logs",
    questionDetail: "Question Details",
    manualPaperPicker: "Manual Paper Picker",
    paperDetail: "Paper Details",
    examDetail: "Exam Details",
    attemptDetail: "Attempt Details",
    dockerInstanceDetail: "Instance Details",
  },
  preferences: {
    entry: "Preferences",
    title: "Personal Preferences",
    actions: {
      reset: "Reset to defaults",
    },
    fields: {
      locale: "Language",
      navTheme: "Navigation theme",
      layout: "Layout mode",
      contentWidth: "Content width",
      colorPrimary: "Primary color",
      fixedHeader: "Fixed header",
      fixSiderbar: "Fixed sider",
      splitMenus: "Split menus",
      colorWeak: "Color weak mode",
    },
    options: {
      navThemeSystem: "Follow system",
      navThemeLight: "Light",
      navThemeDark: "Dark",
      layoutMix: "Mix",
      layoutSide: "Side",
      layoutTop: "Top",
      contentFluid: "Fluid",
      contentFixed: "Fixed",
    },
  },
};
